import type { WRelatedLinkView } from '@zola/svc-web-api-ts-client';

// Hardcoding related links before adding to internal SEO API
const relatedLinks: WRelatedLinkView[] = [
  {
    title: 'Clemson',
    url_path: '/wedding-planning/website/design/clemson',
  },
  {
    title: 'Moonlight',

    url_path: '/wedding-planning/website/design/moonlight',
  },
  {
    title: 'Blake',
    url_path: '/wedding-planning/website/design/blake',
  },
  {
    title: 'Abbey',
    url_path: '/wedding-planning/website/design/abbey',
  },
  {
    title: 'Napa',
    url_path: '/wedding-planning/website/design/napa',
  },
  {
    title: 'Violin',
    url_path: '/wedding-planning/website/design/violin',
  },
  {
    title: 'Splendor',
    url_path: '/wedding-planning/website/design/splendor-black',
  },
  {
    title: 'Franklin',
    url_path: '/wedding-planning/website/design/franklin',
  },
  {
    title: 'Cruise',
    url_path: '/wedding-planning/website/design/cruise',
  },
  {
    title: 'Florence',
    url_path: '/wedding-planning/website/design/florence',
  },
  {
    title: 'Heaven',
    url_path: '/wedding-planning/website/design/heaven',
  },
  {
    title: 'Peak',
    url_path: '/wedding-planning/website/design/peak',
  },
];

export default relatedLinks;
